module.exports = __webpack_public_path__ + "img/DatosVuelo64.c97d2fe9.png";